import SpinnerWrapper from "@arelia-components/ui-atoms/SpinnerWrapper";
import { LabeledValue } from "@arelia-types/index";
import styled from "@emotion/styled";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, tableCellClasses } from "@mui/material";
import { sumBy } from "lodash";
import { useMemo } from "react";

export type Props = {
  rows: LabeledValue<number>[] | undefined;
  isLoading: boolean;
  onRowClick: (type: string) => void
};

export default function TableSummary({ rows = [], isLoading, onRowClick }: Props) {
  const StyledTableCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.body}`]: {
      borderTop: "3px solid #000",
    },
  }));

  const total = useMemo(() => sumBy(rows, x => x.value), [rows]);

  return (
    <TableContainer
      component={Paper}
      sx={styles.container}
    >
      <SpinnerWrapper loading={isLoading}>
        <Table sx={styles.table}>
          <TableHead>
            <TableRow >
              <TableCell>Royalty Type</TableCell>
              <TableCell>Percentage</TableCell>
              <TableCell>Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows?.map(r => (
            <TableRow key={r.label} onClick={() => onRowClick(r.label)} sx={styles.tableRow}>
              <TableCell>{r.label}</TableCell>
              <TableCell>{Math.round((r.value / total) * 100 * 100) / 100} %</TableCell>
              <TableCell>$ {r.value.toFixed(2)}</TableCell>
            </TableRow>
            ))}
            <TableRow>
              <StyledTableCell></StyledTableCell>
              <StyledTableCell></StyledTableCell>
              <StyledTableCell>
                <Typography variant="h4">Grand total $ {total.toFixed(2)}</Typography>
              </StyledTableCell>
            </TableRow>
          </TableBody>
        </Table>
      </SpinnerWrapper>
    </TableContainer>
  );
}

const styles = {
  container: {
    gridColumn: "span 12",
    gridRow: "span 6",
    padding: "20px",
  },
  table: { width: '100%' },
  tableRow: { cursor: "pointer", '&:hover': { backgroundColor: "#f5f5f5" }}
};